import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { DefaultOrder } from 'types/order';
import { useQueryFilters, useQueryOrder } from 'hooks/routes';
import { Messages } from 'constants/messages';
import { showInfoToast } from 'components/Toast';

const FILE_NAME = 'ExportIraUsers.csv';

export const useExportIndependentIraUsers = () => {
  const [order] = useQueryOrder();
  const {
    status,
    userProfileType,
    custodianType,
    displaySepIra,
    onlyFunded,
    accountClosed,
    search,
  } = useQueryFilters();
  const defaultOrder: DefaultOrder<'fullName'> = ['fullName', 'asc'];

  const queryOrder = !order
    ? { orderBy: defaultOrder[0] }
    : order[1] === 'asc'
    ? { orderBy: order[0] }
    : { orderByDesc: order?.[0] ?? '' };

  const params = {
    ...(status ? { status } : {}),
    ...(userProfileType ? { userProfileType } : {}),
    ...(custodianType ? { custodianType } : {}),
    ...(displaySepIra ? { displaySepIra } : {}),
    ...(onlyFunded ? { onlyFunded } : {}),
    ...(accountClosed ? { accountClosed } : {}),
    ...(search ? { search } : {}),
    ...queryOrder,
  };

  const mutate = async () => {
    const { data } = await api.exportIndependentIraUsers(params);

    return data;
  };

  return useMutation<Blob, AxiosError>(mutate, {
    onSuccess: (blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', FILE_NAME);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      showInfoToast(Messages.successExportCsv);
    },
  });
};
